import React from "react";
import "../App.css";
import "./Home.css";

function Home() {
    return (
        <div className="home">
            <div className="home-content">
                <div className="intro-text">
                    <h1 className="home-title">Tisztelt Szakfelelős Kollégák!</h1>
                    <p>
                        Az egyetemi képzésfejlesztési folyamat részeként, a folyamatosan változó munkaerőpiaci,
                        technológiai környezet, valamint a hallgatók újabb generációinak speciális jellemzői miatt,
                        illetve nem utolsósorban minőségbiztosítási folyamatok, az akkreditációs feltételek és elvárások,
                        a nemzetközi akkreditációs folyamatok figyelembe vételével a képzésekhez kapcsolódó,
                        többségében már ma is meglévő és jól működő külső munkaerőpiaci, társadalmi kapcsolatrendszer fejlesztését,
                        intézményesítését tűztük ki célul és feladatul.
                    </p>
                    <p>
                        A 2022/2023-as tanévben megkezdett értékelési munkát folytatva 2024-től a szakokra vonatkozó értékeléseket
                        már online formában lehet elkészíteni. A célunk, hogy a jövőben ezek a jelentések lehetőleg automatikusan
                        létrejöjjenek és az adatoknak csak az értékelése háruljon a szakfelelősre és a külső támogató partnerekre.
                    </p>
                    <p>A szakjelentés célja többszintű:</p>
                    <ul>
                        <li>Belső ellenőrzési folyamat:</li>
                        <ul>
                            <li>a szakfelelős évente értékeli a szakot, és láthatja a szükséges beavatkozási pontokat;</li>
                            <li>alapot nyújt a mintatanterv újragondolásához, új tárgyak bevezetéséhez, figyelembe véve a folyamatosan változó munkaerőpiaci, technológiai környezetet és a hallgatók generációs sajátosságainak speciális jellemzőit;</li>
                            <li>segítséget ad a szakot bemutató anyagok elkészítéséhez;</li>
                        </ul>
                        <li>MAB akkreditációs feltételeinek és elvárásainak megfelelés:</li>
                        <ul>
                            <li>a MAB részére bemutatásra kerül, hogy a szakok a PDCA ciklusnak megfelelően az éves munkáikat, tevékenységeiket elvégezve, évente értékelnek, megtalálják a kritikus pontokat, ahol beavatkozás szükséges és megteszik a szükséges javaslatokat a fejlesztésre.</li>
                        </ul>
                        <li>Nemzetközi akkreditációs elvárásainak megfelelő értékelések</li>
                        <li>Visszajelzés a szak működéséről:</li>
                        <ul>
                            <li>Szakfelelős, szakbizottság, dékán részére</li>
                            <li>HÖK, hallgatók részére</li>
                            <li>Külső piaci partnerek felé</li>
                        </ul>
                    </ul>

                    <p>
                        Az értékelő anyag a szakkal kapcsolatosan minden olyan fontos kérdéskört tartalmaz, amelyek a MAB akkreditáció, a nemzetközi akkreditációk, a minőségellenőrzési munka és a szak folyamatos működése szempontjából szükségesek lehetnek.
                    </p>
                    <p>Köszönjük az együttműködésüket és támogatásukat a képzésfejlesztési munkában!</p>
                </div>
                {/*<img src="/assets/folyamat.svg" alt="Folyamatábra" />*/}
            </div>
        </div>
    );
}

export default Home;
